import { render, staticRenderFns } from "./empWagesDetailColumnsList.vue?vue&type=template&id=ce18affe&scoped=true&"
import script from "./empWagesDetailColumnsList.vue?vue&type=script&lang=js&"
export * from "./empWagesDetailColumnsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce18affe",
  null
  
)

export default component.exports